import { ITipoDocumentoPrestacaoContasResponse } from "models/response/tipo-documento-prestacao-contas-response";

export type PrestacaoContasTiposState = {
    tipos: ITipoDocumentoPrestacaoContasResponse[];
    loading: boolean;
};

export enum ACTION_TYPES {
    setTipos = 'setTipos',
    setLoading = 'setLoading',
}

export const PrestacaoContasTiposReducer = (state: PrestacaoContasTiposState, action: any): PrestacaoContasTiposState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setTipos:
            return { ...state, tipos: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
